import React, { useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import Destinations from './components/Destinations/Destinations';
import Atouts from './components/Atouts/Atouts';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Paiement from './components/Paiement/Paiement';
import NousContacter from './components/NousContacter/NousContacter';
import Tracking from './components/Tracking/TrackingService';
import { useTracking } from './hooks/useTracking';
import './App.css';

export default function App() {
  // Initialisation du hook de tracking (simule Google Analytics)
  const { trackEvent } = useTracking();

  useEffect(() => {
    // Smooth scroll global
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);



  return (
    <div className="app">
      <Navbar trackEvent={trackEvent} />
      <main>
        <Hero trackEvent={trackEvent} />
        <Services trackEvent={trackEvent} />
        <Destinations trackEvent={trackEvent} />
        <Atouts trackEvent={trackEvent} />
        <Paiement trackEvent={trackEvent} />
        <NousContacter trackEvent={trackEvent} />
        <Contact trackEvent={trackEvent} />
        <Tracking trackEvent={trackEvent} />
      </main>
      <Footer />
    </div>
  );
}
